import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import memoizeOne from 'memoize-one';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable, LogChipType, LogChipCategory, LogChipProductType, DatePickerFilter } from 'data/components';
import { uiTheme, Toastr } from 'data/common';
import { getLogsNiceenergie } from '../../data/LogsNiceenergie/actions';
import Background from '../../../../assets/images/background-appmenu.jpg';
import tools from '../../../../data/common/tools';

class LogsNiceenergie extends PureComponent {
  static propTypes = {
    getLogsNiceenergie: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    supportUsers: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
  };

  static contextTypes = {
    changeLoggingTheme: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      logs: [],
      fromDate: moment()
        .add(-1, 'month')
        .unix(),
      toDate: moment().unix(),
      fromDateLimitMessage: '',
      toDateLimitMessage: ''
    };
    this.env = 'niceenergie';
  }

  componentDidMount() {
    const { changeLoggingTheme } = this.context;
    changeLoggingTheme(uiTheme(this.env));
    this.refreshLogs();
  }

  refreshLogs = () => {
    const { getLogsNiceenergie } = this.props;
    const { fromDate, toDate } = this.state;
    this.setState({ loading: true });
    getLogsNiceenergie(fromDate, toDate)
      .then(data => {
        if (data.success) {
          this.setState({
            loading: false,
            logs: data.logsArray
          });
        }
      })
      .catch(() => {
        Toastr.error(Translator.translate('logging.actions.getLogs', Translator.translate(`${this.env}.menuItem`)));
        this.setState({
          loading: false
        });
      });
  };

  onFromDateChange = date => {
    const { toDate } = this.state;
    const fromDateLimit = moment(date).add(1, 'month');

    if (fromDateLimit < moment.unix(toDate)) {
      this.setState({
        fromDate: moment(date).unix(),
        toDate: moment(fromDateLimit).unix(),
        toDateLimitMessage: Translator.translate('logging.table.body.toDateLimitMessage'),
        fromDateLimitMessage: ''
      });
    } else {
      this.setState({
        fromDate: moment(date).unix(),
        toDateLimitMessage: '',
        fromDateLimitMessage: ''
      });
    }
  };

  onToDateChange = date => {
    const { fromDate } = this.state;
    const toDateLimit = moment(date).add(-1, 'month');

    if (toDateLimit > moment.unix(fromDate)) {
      this.setState({
        toDate: moment(date).unix(),
        fromDate: moment(toDateLimit).unix(),
        fromDateLimitMessage: Translator.translate('logging.table.body.fromDateLimitMessage'),
        toDateLimitMessage: ''
      });
    } else {
      this.setState({
        toDate: moment(date).unix(),
        toDateLimitMessage: '',
        fromDateLimitMessage: ''
      });
    }
  };

  navigateToDetail = rowData => {
    const { history } = this.props;
    let url = '';
    const row = rowData.data;

    if (rowData.category === 'product') url = `/${this.env}/products/${row.homeId}/${row.targetType}/${row.targetId}`;
    else if (row.targetType === 'box') url = `/${this.env}/${row.targetType}`;
    else if (row.targetType === 'user') return null;
    else url = `/${this.env}/${row.targetType}/detail/${row.targetId}`;

    if (row.targetHash) url += row.targetHash;
    return history.push({ pathname: url });
  };

  renderData = memoizeOne((logs, supportUsers) => {
    let result = [];

    logs.forEach(log => {
      let userLabel = '';
      supportUsers.map(user => {
        if (user.get('_id') === log.userId) {
          userLabel = `${user.get('lastname')} ${user.get('firstname')}`;
        }
      });
      result.push({
        category: log.category,
        type: log.type,
        date: log.timestamp,
        action: log.action,
        agent: userLabel ? userLabel : log.userId,
        message: log.message,
        data: log.data
      });
    });
    return result;
  });
  renderActions = memoizeOne(() => {
    return {
      row: [
        {
          icon: ViewIcon,
          tooltip: Translator.translate('general.showDetail'),
          onClick: this.navigateToDetail
        }
      ],
      toolbar: []
    };
  });

  renderColumns = memoizeOne(() => {
    return [
      {
        title: Translator.translate('general.table.column.category'),
        name: 'category',
        render: (row, data, value) => {
          let res = null;
          switch (value) {
            case 'user':
              res = <LogChipCategory category="user" />;
              break;
            case 'home':
              res = <LogChipCategory category="home" />;
              break;
            case 'box':
              res = <LogChipCategory category="box" />;
              break;
            case 'userManager':
              res = <LogChipCategory category="userManager" />;
              break;
            case 'fheTicket':
              res = <LogChipCategory category="ticket" />;
              break;
            case 'craftsman':
              res = <LogChipCategory category="craftsman" />;
              break;
            case 'product':
              res = <LogChipCategory category="product" />;
              break;
            case 'management':
              res = <LogChipCategory category="management" />;
              break;
          }
          return res;
        }
      },
      {
        title: Translator.translate('general.table.column.type'),
        name: 'type',
        render: (row, data, value) => {
          let res = null;
          switch (value) {
            case 'home':
              res = <LogChipCategory category="home" />;
              break;
            case 'box':
              res = <LogChipCategory category="box" />;
              break;
            case 'user':
              res = <LogChipCategory category="user" />;
              break;
            case 'history':
              res = <LogChipCategory category="history" />;
              break;
            case 'airzone':
              res = <LogChipProductType productType="airzone" />;
              break;
            case 'zwave':
              res = <LogChipProductType productType="zwave" />;
              break;
            case 'drive_elec':
              res = <LogChipProductType productType="drive_elec" />;
              break;
            case 'sensor':
              res = <LogChipProductType productType="sensor" />;
              break;
            case 'smart_plug':
              res = <LogChipProductType productType="smart_plug" />;
              break;
            case 'heat_and_cool':
              res = <LogChipProductType productType="heat_and_cool" />;
              break;
            case 'home_connect':
              res = <LogChipProductType productType="home_connect" />;
              break;
            case 'volet':
              res = <LogChipProductType productType="volet" />;
              break;
            case 'smart_meter':
              res = <LogChipProductType productType="smart_meter" />;
              break;
          }
          return res;
        }
      },
      {
        title: Translator.translate('general.table.column.date'),
        name: 'date',
        customSort: tools.sortDate
      },
      {
        title: Translator.translate('general.table.column.action'),
        name: 'action',
        render: (row, data, value) => {
          let res = null;
          switch (value) {
            case 'modification':
              res = <LogChipType type="modification" />;
              break;
            case 'information':
              res = <LogChipType type="information" />;
              break;
            case 'suppression':
              res = <LogChipType type="suppression" />;
              break;
            case 'creation':
              res = <LogChipType type="creation" />;
              break;
          }
          return res;
        }
      },
      {
        title: Translator.translate('general.table.column.agent'),
        name: 'agent'
      },
      {
        title: Translator.translate('general.table.column.message'),
        name: 'message'
      }
    ];
  });

  render() {
    const { loading, fromDate, toDate, fromDateLimitMessage, toDateLimitMessage, logs } = this.state;
    const { classes, supportUsers } = this.props;
    return (
      <Fragment>
        <div className={classes.dateAreaContainer}>
          <DatePickerFilter
            fromDate={moment.unix(fromDate).toDate()}
            toDate={moment.unix(toDate).toDate()}
            fromDateLimitMessage={fromDateLimitMessage}
            toDateLimitMessage={toDateLimitMessage}
            refreshFunc={this.refreshLogs}
            onFromDateChange={this.onFromDateChange}
            onToDateChange={this.onToDateChange}
          />
        </div>
        <FHETable
          idTable={`loggingList${this.env}`}
          columns={this.renderColumns()}
          data={this.renderData(logs, supportUsers)}
          actions={this.renderActions()}
          title={Translator.translate(`logging.table.title`, Translator.translate(`${this.env}.menuItem`))}
          emptyDataSourceMessage={Translator.translate('logging.table.body.emptyDataSourceMessage')}
          isLoading={loading}
        />
        <div className={classes.envContainer} />
      </Fragment>
    );
  }
}

const styles = theme => ({
  envContainer: {
    background: `radial-gradient(circle, transparent 80%, black 150%), linear-gradient(to top, ${theme.palette.primary.main} -30%, transparent 120%), url(${Background})`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundBlendMode: 'overlay',
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '-5'
  },
  dateAreaContainer: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: 15,
    marginBottom: 20
  }
});

function mapStateToProps(state) {
  let supportUsers = state.environments.logging.data.SupportUsers.get('list');

  return {
    profile: state.data.user,
    supportUsers: supportUsers
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    dispatch => bindActionCreators({ getLogsNiceenergie }, dispatch)
  )(withStyles(styles, { withTheme: true })(LogsNiceenergie))
);



// WEBPACK FOOTER //
// ./environments/logging/scenes/LogsNiceenergie/index.js